import { render, staticRenderFns } from "./AnalysisCategory.vue?vue&type=template&id=6b84afdc&"
import script from "./AnalysisCategory.vue?vue&type=script&lang=ts&"
export * from "./AnalysisCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports